<script setup>
import { WdsPillActive, WdsPillSelect } from '@wds/components';

const props = defineProps({
  propertyTypeObj: {
    type: Object,
    default: () => ({}),
  },
  locationInfo: {
    type: Object,
    required: false,
  },
  activeFilter: {
    type: Object,
    default: () => ({}),
  },
});
const { useFilter } = useFilters();
const { useUrl } = useUrls();
const { $tracking } = useNuxtApp();
const { t } = useI18n();

function getFilterTitle(filter) {
  if (isFilterActive(filter.key)) {
    return t('t_VIEWALLPROPERTIESINLOCATION', {
      PROPERTYTYPE: t(props.propertyTypeObj?.transcode),
      LOCATION: props.locationInfo?.name,
    });
  }

  return filter.transcode_alttext;
}

function redirectToFilterPage(selectedFilter) {
  const locationData = {
    propertyTypeSlug: props.propertyTypeObj?.slug,
    urlFriendlyContinent: props.locationInfo?.urlFriendlyContinent,
    urlFriendlyCountry: props.locationInfo?.urlFriendlyCountry,
    urlFriendlyCity: props.locationInfo?.urlFriendlyName,
    urlFilterSlug: isFilterActive(selectedFilter.key) ? '' : t(selectedFilter?.slug),
  };

  return useUrl.getCityPageUrl(locationData);
}

function onFilterOptionClick(filter) {
  const trackingInfo = {
    segment: {
      event_name: 'Destination Landing Page Event',
      action: `Page Filter ${filter} Clicked`,
    },
  };

  $tracking.onPageFilterClick(trackingInfo.segment);
}

function isFilterActive(filter) {
  return filter === props.activeFilter?.key;
}
</script>

<template>
  <div class="filters-container">
    <span class="filters-title">{{ $t('t_TITLEQUICKFILTERS') }}</span>
    <div class="filters-list-wrapper">
      <div class="filters-list">
        <component
          :is="isFilterActive(filter.key) ? WdsPillActive : WdsPillSelect"
          v-for="filter in useFilter.getTranslatedFiltersList.value"
          :key="filter.key"
          class="filter-pill"
          :href="redirectToFilterPage(filter)"
          :text="filter.transcode_title"
          :title="getFilterTitle(filter)"
          :aria-label="getFilterTitle(filter)"
          :icon-start="filter.asset"
          :icon-end="isFilterActive(filter.key) ? 'close' : ''"
          rel="noopener"
          @click="onFilterOptionClick(filter.key)"
          @keyup.enter="onFilterOptionClick(filter.key)"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.filters-container {
  display: flex;
  flex-direction: column;
  min-width: 100%;

  .filters-title {
    @include body-2-reg;
  }

  .filters-list-wrapper {
    overflow: hidden;
    border-radius: $wds-spacing-m;
    display: flex;

    .filters-list {
      display: inline-flex;
      align-items: center;
      gap: $wds-spacing-s;
      padding: $wds-spacing-s $wds-spacing-xs;
      overflow: auto hidden;
      flex: 1;

      .filter-pill {
        fill: $wds-color-ink-dark;
      }
    }
  }
}
</style>
